import { IItem, ITitleLeafImageTextRow } from './types';
import { RichText } from 'prismic-reactjs';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import CustomPrismicLink from '@components/CustomPrismicLink';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapTitleLeafImageTextRow } from './mapTitleLeafImageTextRow';

const TitleLeafImageTextRow: React.FC<ITitleLeafImageTextRow> = ({
  items,
  title,
}) => {
  return (
    <section className="root">
      <RichText render={title} />
      {items.map((item: IItem, index: number) => {
        return (
          <div
            key={index}
            className={`container ${
              item.hasPictureOnRight ? `container-right` : ``
            }`}
          >
            <div className="image-container">
              <div className="image-bubble">
                <ResponsiveImage
                  src={item.image}
                  alt={item.alt}
                  objectFit="contain"
                  layout="fill"
                />
              </div>
            </div>
            <div
              className={`text-container ${
                item.hasPictureOnRight ? `text-container-right` : ``
              }`}
            >
              <RichText
                render={item.text}
                serializeHyperlink={CustomPrismicLink}
              />
            </div>
          </div>
        );
      })}
      <style jsx>{`
        .petal {
          position: absolute;
          margin-top: 70px;
        }

        .root > :global(h1) {
          margin-bottom: var(--space-4);
        }

        .container :global(p) {
          padding-top: 15px;
        }

        .container {
          width: 70%;
          margin: auto;
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .container:not(:last-child) {
          margin-bottom: var(--space-4);
        }

        .container-right {
          flex-direction: row-reverse;
        }

        .image-container {
          min-width: 160px;
          min-height: 160px;
          border-radius: 50%;
          background-color: white;
          position: absolute;
          display: flex;
          align-items: center;
        }

        .image-bubble {
          position: relative;
          width: 100%;
          height: 70px;
        }

        .text-container {
          padding: 30px 30px 30px 180px;
          width: 100%;
          margin-left: 80px;
          background-color: var(--clr-primary-5);
          border-radius: 4px;
        }

        .text-container-right {
          padding: 30px 180px 30px 30px;
          margin-left: 0;
          margin-right: 80px;
        }

        .text-container :global(*) {
          color: var(--black);
        }

        .text-container :global(a) {
          transition: all 0.3s ease;
          color: var(--clr-tertiary-1);
          text-decoration: underline;
          line-height: 1.375;
          cursor: pointer;
        }

        .text-container :global(a:hover) {
          opacity: 0.6;
          text-decoration: none;
        }

        @media (max-width: 800px) {
          .petal {
            margin-top: inherit;
            bottom: -20px;
            right: 0;
          }

          .container {
            width: 100%;
            margin-top: 0;
            flex-direction: column;
            align-items: center;
          }

          .image-container {
            position: relative;
            margin: auto;
            top: 50px;
            min-width: 100px;
            min-height: 100px;
          }

          .image-bubble {
            height: 50px;
          }

          .text-container {
            padding: 60px 30px 30px 30px;
            margin-left: auto;
          }
        }
      `}</style>
    </section>
  );
};

export default withSlice(TitleLeafImageTextRow, mapTitleLeafImageTextRow);
